import Swiper, {Navigation} from "swiper";
import {LG_WIDTH} from "@main/helpers/const.js";

const NUMBER_OF_VISIBLE_SLIDES = 4;

class LicensesSlider {
    swiper 

    constructor(el) {
        this.el = el;
        this.createSlider();
        this.bindEventListeners();
    }

    /**
     * Скрываем последний видимый слайд при пролистывании слайдера.
     *
     * @returns {void}
     */
    bindEventListeners() {
        this.swiper.on("slideChange", () => {
            let visibleSlides = [];
            this.swiper.slides.forEach(slide => {   
                slide.classList.remove("hide");
                
                if (slide.classList.contains("swiper-slide-visible")) {
                    visibleSlides.push(slide);
                }
            })

            const lastVisibleSlide = visibleSlides[visibleSlides.length - 1];
            if (visibleSlides.length > NUMBER_OF_VISIBLE_SLIDES) {
                lastVisibleSlide.classList.add("hide");
            }            
        });
    }

    createSlider() {
        this.swiper = new Swiper(this.el, {
            slidesPerView: "auto",
            modules: [Navigation],
            watchSlidesProgress: true,
            navigation: {
                nextEl: ".js-licenses-next",
                prevEl: ".js-licenses-prev"
            },
            breakpoints: {
                [LG_WIDTH]: {
                    slidesPerView: NUMBER_OF_VISIBLE_SLIDES,
                    spaceBetween: 16,
                },
            },
            on: {
                init: () => {
                    const visibleSlides = this.el.querySelectorAll(".swiper-slide-visible");
                    visibleSlides[NUMBER_OF_VISIBLE_SLIDES]?.classList.add("hide");
                },
            },
        });
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-licenses-slider")
        .forEach(slider => new LicensesSlider(slider));
});
